import React, { useState, useEffect } from "react";
import Content from "../layout/content/Content";
import Head from "../layout/head/Head";
import {
  UncontrolledPopover,
  PopoverHeader,
  PopoverBody,
  Spinner,
  Alert,
  Modal,
  ModalHeader,
  ModalBody,
  ModalFooter,
  Nav,
  NavItem,
  NavLink,
} from "reactstrap";
import {
  Block,
  BlockDes,
  BlockHead,
  BlockHeadContent,
  BlockTitle,
  Icon,
  Button,
  Row,
  Col,
  PreviewAltCard,
} from "../components/Component";
import { Select } from "antd";
import { baseURLs } from "../utils/Constants";
import { getAxiosHeaders } from "../utils/Utils";
import { Link } from "react-router-dom";
import classNames from "classnames";
import axios from "axios";
import DatePicker from "react-datepicker";
import moment from "moment";
import { InfoModal } from "./components/AlertModals";

const ProfitAndLoss = ({ history, match }) => {
  const [sm, updateSm] = useState(false);
  const [loading, setLoading] = useState(true);
  const [loadingReport, setLoadingReport] = useState(true);
  const [businessID, setBusinessID] = useState("");
  const [businessInfo, setBusinessInfo] = useState({});
  const [incomeStatementReport, setIncomeStatementReport] = useState([]);
  const [incomeStatementReportType, setIncomeStatementReportType] =
    useState("simple");
  const [revenueCategory, setRevenueCategory] = useState({
    simple: [],
    standard: [],
  });
  const [COGSCategory, setCOGSCategory] = useState({
    simple: [],
    standard: [],
  });
  const [OPEXCategory, setOPEXCategory] = useState({
    simple: [],
    standard: [],
  });
  const [CAPEXCategory, setCAPEXCategory] = useState({
    simple: [],
    standard: [],
  });
  const [errorMessage, setErrorMessage] = useState("");
  const [accountingType, setAccountingType] = useState("cash_accounting");
  const [periodType, setPeriodType] = useState("month");
  const [periodDate1, setPeriodDate1] = useState(new Date());
  const [periodDate2, setPeriodDate2] = useState(null);
  const [periodDate3, setPeriodDate3] = useState(null);
  const [activeModal, setActiveModal] = useState(null);

  const toggleModal = (modal) => {
    if (activeModal === modal) {
      setActiveModal(null);
    } else {
      setActiveModal(modal);
    }
  };

  const groupCategories = (data, reportType, key) => {
    const grouped = {};

    data.forEach(({ period, [reportType]: report }) => {
      const categories = report?.[key]?.categories || [];

      categories.forEach((cat) => {
        if (!grouped[cat.category]) {
          grouped[cat.category] = {
            category: cat.category,
            info: [],
          };
        }

        grouped[cat.category].info.push({
          period,
          total_amount: cat.total_amount,
        });
      });
    });

    return Object.values(grouped).sort((a, b) =>
      a.category.localeCompare(b.category)
    );
  };

  const getIncomeStatement = (businessID) => {
    setErrorMessage("");

    if (!periodDate1) {
      setErrorMessage("Period Date 1 is required");
      return;
    }

    setLoadingReport(true);
    setActiveModal(null);
    let dateFormat = periodType === "year" ? "YYYY" : "YYYY-MM";

    axios
      .get(baseURLs.API_URL + "/reports/income-statement", {
        params: {
          business_id: businessID,
          accounting_type: accountingType,
          period_type: periodType,
          period_date_1: moment(periodDate1).format(dateFormat),
          period_date_2: !periodDate2
            ? null
            : moment(periodDate2).format(dateFormat),
          period_date_3: !periodDate3
            ? null
            : moment(periodDate3).format(dateFormat),
        },
        headers: getAxiosHeaders().headers,
      })
      .then((response) => {
        let responseInfo = response.data;
        let report = responseInfo.data.report;

        // Create grouped and sorted categories
        const _simpleRevenueCategory = groupCategories(
          report,
          "simple_report",
          "revenue"
        );
        const _standardRevenueCategory = groupCategories(
          report,
          "standard_report",
          "revenue"
        );
        const _simpleCOGSCategory = groupCategories(
          report,
          "simple_report",
          "cost_of_goods_sold"
        );
        const _standardCOGSCategory = groupCategories(
          report,
          "standard_report",
          "cost_of_goods_sold"
        );
        const _simpleOPEXCategory = groupCategories(
          report,
          "simple_report",
          "operating_expenses"
        );
        const _standardOPEXCategory = groupCategories(
          report,
          "standard_report",
          "operating_expenses"
        );
        const _simpleCAPEXCategory = groupCategories(
          report,
          "simple_report",
          "capital_expenditures_expenses"
        );
        const _standardCAPEXCategory = groupCategories(
          report,
          "standard_report",
          "capital_expenditures_expenses"
        );

        // get all expenses categories
        setRevenueCategory({
          simple: _simpleRevenueCategory,
          standard: _standardRevenueCategory,
        });
        setCOGSCategory({
          simple: _simpleCOGSCategory,
          standard: _standardCOGSCategory,
        });

        setOPEXCategory({
          simple: _simpleOPEXCategory,
          standard: _standardOPEXCategory,
        });

        setCAPEXCategory({
          simple: _simpleCAPEXCategory,
          standard: _standardCAPEXCategory,
        });

        setIncomeStatementReport(report);
        setLoadingReport(false);
      })
      .catch((error) => {
        try {
          let errorResponse = error.response.data;

          if (error.response.status === 401) {
            history.push(`${process.env.PUBLIC_URL}/expired-session`);
            return;
          }

          if (error.response.status === 404) {
            history.push(`${process.env.PUBLIC_URL}/not-found`);
            return;
          }

          if (error.response.status === 403) {
            history.push(
              `${process.env.PUBLIC_URL}/unauthorized/b/${businessID}`
            );
            return;
          }

          if (error.response.status === 402) {
            history.push(
              `${process.env.PUBLIC_URL}/subscription/b/${businessID}`
            );
            return;
          }

          let errorMessage = "Error: Could not connect to server";
          if (errorResponse.hasOwnProperty("error")) {
            errorMessage = errorResponse.error;
          }

          setLoadingReport(false);
          setErrorMessage(errorMessage);
        } catch (e) {
          console.log(e);
          // history.push(`${process.env.PUBLIC_URL}/server-offline`);
        }
      });
  };

  const printDivContent = (divId, title) => {
    const divContents = document.getElementById(divId).innerHTML;
    let a = window.open("", "_blank");
    a.document.write("<html>");
    a.document.write("<head>");
    a.document.write("<title>" + title + "</title>");
    a.document.write(
      '<link rel="stylesheet" href="/custom/income-statement.css?ver=0.2">'
    );
    a.document.write("</head >");
    a.document.write('<body style="background: #ffffff;">');
    a.document.write(divContents);
    a.document.write("</body></html>");
    a.document.close();
    setTimeout(() => {
      a.print();
    }, 500);
  };

  useEffect(() => {
    setLoading(true);
    const businessID = parseInt(match.params.businessID, 10);
    if (!Number.isInteger(businessID)) {
      history.push(`${process.env.PUBLIC_URL}/not-found`);
      return;
    }

    localStorage.setItem("current_business_id", businessID);
    let businesses = JSON.parse(localStorage.getItem("my_businesses"));
    let currentBusiness = businesses?.find(
      (business) => business.business_id == businessID
    );

    if (currentBusiness == undefined || null || "") {
      history.push(`${process.env.PUBLIC_URL}/not-found`);
      return;
    }

    setBusinessInfo(currentBusiness);
    setBusinessID(businessID);
    getIncomeStatement(businessID);
    setLoading(false);
  }, [match.params.businessID]);

  return (
    <React.Fragment>
      <Head title="Profit & Loss Report" />
      <Content>
        {loading ? (
          <Block className="nk-block-middle nk-auth-body text-center wide-xs">
            <div className="inner-pre-loader">
              <Spinner color="dark" />
            </div>
          </Block>
        ) : (
          <>
            <BlockHead size="sm">
              <div className="nk-block-between">
                <BlockHeadContent>
                  <BlockDes className="text-soft">
                    <p>{businessInfo.name}</p>
                  </BlockDes>
                  <BlockTitle page tag="h3">
                    Profit &amp; Loss Report
                  </BlockTitle>
                </BlockHeadContent>
                <BlockHeadContent>
                  <div className="toggle-wrap nk-block-tools-toggle">
                    <Button
                      className={`btn-icon btn-trigger toggle-expand me-n1 ${
                        sm ? "active" : ""
                      }`}
                      onClick={() => updateSm(!sm)}
                    >
                      <Icon name="more-v"></Icon>
                    </Button>
                    <div
                      className="toggle-expand-content"
                      style={{ display: sm ? "block" : "none" }}
                    >
                      <ul className="nk-block-tools g-3">
                        <li className="nk-block-tools-opt">
                          <Button
                            color="primary"
                            disabled={loadingReport}
                            onClick={() => toggleModal("filterModal")}
                          >
                            <Icon name="calender-date" />
                            <span>Filter Report</span>
                          </Button>
                        </li>
                        <li className="nk-block-tools-opt">
                          <Button
                            color="light"
                            outline
                            disabled={loadingReport}
                            onClick={() => {
                              printDivContent(
                                "profit_loss",
                                `${businessInfo.name} - Profit & Loss Report`
                              );
                            }}
                          >
                            <Icon name="printer" />
                            <span>Print</span>
                          </Button>
                        </li>
                        <li className="nk-block-tools-opt">
                          <Button
                            color="light"
                            outline
                            disabled={loadingReport}
                            onClick={() => {
                              toggleModal("infoModal");
                            }}
                          >
                            <Icon name="info" />
                          </Button>
                        </li>
                      </ul>
                    </div>
                  </div>
                </BlockHeadContent>
              </div>
            </BlockHead>

            {loadingReport ? (
              <Block className="nk-block-middle nk-auth-body text-center wide-xs">
                <div className="inner-pre-loader">
                  <Spinner color="dark" />
                </div>
              </Block>
            ) : (
              <Block>
                <Row className="g-gs justify-content-center mt-3">
                  <Col lg="10">
                    <Nav tabs className="mt-5 justify-content-center">
                      <NavItem>
                        <NavLink
                          tag="a"
                          href="#simple-report"
                          className={`${
                            incomeStatementReportType === "simple"
                              ? `active`
                              : ``
                          }`}
                          onClick={(ev) => {
                            ev.preventDefault();
                            setIncomeStatementReportType("simple");
                          }}
                        >
                          <Icon name="file" /> <span>Simple Report</span>
                        </NavLink>
                      </NavItem>
                      <NavItem>
                        <NavLink
                          tag="a"
                          href="#standard-report"
                          className={`${
                            incomeStatementReportType === "standard"
                              ? `active`
                              : ``
                          }`}
                          onClick={(ev) => {
                            ev.preventDefault();
                            setIncomeStatementReportType("standard");
                          }}
                        >
                          <Icon name="file-docs" /> <span>Standard Report</span>
                        </NavLink>
                      </NavItem>
                    </Nav>
                  </Col>
                </Row>

                <div id="profit_loss">
                  <Row className="g-gs justify-content-center mt-3">
                    <Col lg="10">
                      <PreviewAltCard>
                        <div className="card-title text-center mt-3">
                          <h4 className="title">{businessInfo.name}</h4>
                          <p className="mb-0">{businessInfo.location}</p>
                          <p>{businessInfo.phone_number}</p>
                          <h6 className="title mt-4 text-capitalize">
                            {incomeStatementReportType} Profit &amp; Loss Report
                          </h6>
                          <p>
                            <small className="text-muted">
                              (
                              {`${
                                accountingType === "cash_accounting"
                                  ? `Cash Accounting`
                                  : `Accrual Accounting`
                              }`}
                              )
                            </small>
                          </p>
                          <p>
                            For the Period Ended
                            {incomeStatementReport.map((data, index) => {
                              let period =
                                index === 0
                                  ? `${data.period}`
                                  : `, ${data.period}`;
                              return (
                                <span className="ps-1 fw-bold" key={index}>
                                  {period}
                                </span>
                              );
                            })}
                          </p>
                        </div>
                        <div className="pl-container">
                          <table className="table table-bordered text-left">
                            <thead>
                              <tr>
                                <th scope="col">Revenue</th>
                                {incomeStatementReport.map((data, index) => {
                                  return (
                                    <th
                                      key={index}
                                      className="text-right"
                                      scope="col"
                                    >
                                      {data.period}
                                    </th>
                                  );
                                })}
                              </tr>
                            </thead>
                            <tbody>
                              {(() => {
                                const data =
                                  incomeStatementReportType === "simple"
                                    ? revenueCategory.simple
                                    : revenueCategory.standard;

                                // Sort periods (optional but useful for consistent display)
                                const periods = incomeStatementReport.map(
                                  (r) => r.period
                                );

                                return data.map((cData, index) => (
                                  <tr key={index}>
                                    <td className="ps-5">{cData.category}</td>
                                    {periods.map((period, pIndex) => {
                                      const match = cData.info.find(
                                        (i) => i.period === period
                                      );
                                      return (
                                        <td key={pIndex} className="text-right">
                                          <small>{businessInfo.currency}</small>{" "}
                                          {match ? match.total_amount : "0.00"}
                                        </td>
                                      );
                                    })}
                                  </tr>
                                ));
                              })()}

                              <tr className="fs-15px">
                                <th scope="row">Total Revenue</th>
                                {incomeStatementReport.map((report, index) => {
                                  return (
                                    <th key={index} className="text-right">
                                      <small>{businessInfo.currency}</small>{" "}
                                      {incomeStatementReportType === "simple"
                                        ? report?.simple_report.revenue
                                            .total_amount
                                        : report?.standard_report.revenue
                                            .total_amount}
                                    </th>
                                  );
                                })}
                              </tr>
                              <tr>
                                <td colSpan="4" className="p-3"></td>
                              </tr>
                              <tr>
                                <th colSpan="4" scope="row">
                                  Cost of Goods Sold
                                </th>
                              </tr>
                              {(() => {
                                const data =
                                  incomeStatementReportType === "simple"
                                    ? COGSCategory.simple
                                    : COGSCategory.standard;

                                // Sort periods (optional but useful for consistent display)
                                const periods = incomeStatementReport.map(
                                  (r) => r.period
                                );

                                return data.map((cData, index) => (
                                  <tr key={index}>
                                    <td className="ps-5">{cData.category}</td>
                                    {periods.map((period, pIndex) => {
                                      const match = cData.info.find(
                                        (i) => i.period === period
                                      );
                                      return (
                                        <td key={pIndex} className="text-right">
                                          <small>{businessInfo.currency}</small>{" "}
                                          {match ? match.total_amount : "0.00"}
                                        </td>
                                      );
                                    })}
                                  </tr>
                                ));
                              })()}

                              <tr className="fs-15px">
                                <th>Total Cost of Goods Sold (COGS)</th>
                                {incomeStatementReport.map((report, index) => {
                                  return (
                                    <th key={index} className="text-right">
                                      <small>{businessInfo.currency}</small>{" "}
                                      {incomeStatementReportType === "simple"
                                        ? report?.simple_report
                                            .cost_of_goods_sold.total_amount
                                        : report?.standard_report
                                            .cost_of_goods_sold.total_amount}
                                    </th>
                                  );
                                })}
                              </tr>
                              <tr>
                                <td colSpan="4" className="p-3"></td>
                              </tr>
                              <tr className="fs-16px">
                                <th scope="row">Gross Profit / (Loss)</th>
                                {incomeStatementReport.map((report, index) => {
                                  const isSimple =
                                    incomeStatementReportType === "simple";
                                  const data = isSimple
                                    ? report?.simple_report
                                    : report?.standard_report;

                                  const isProfit = data?.is_gross_profit;
                                  const amount = data?.gross_income || "0";

                                  const formattedAmount = isProfit
                                    ? amount
                                    : amount.replace("-", "") ||
                                      Math.abs(Number(amount)).toString();

                                  return (
                                    <td key={index} className="text-right">
                                      {isProfit ? (
                                        <span className="text-success">
                                          <small>{businessInfo.currency}</small>{" "}
                                          {formattedAmount}
                                        </span>
                                      ) : (
                                        <span className="text-danger">
                                          (
                                          <small>{businessInfo.currency}</small>{" "}
                                          {formattedAmount})
                                        </span>
                                      )}
                                    </td>
                                  );
                                })}
                              </tr>

                              <tr>
                                <td colSpan="4" className="p-3"></td>
                              </tr>
                              <tr>
                                <th colSpan="4" scope="row">
                                  Operating Expenses
                                </th>
                              </tr>

                              {(() => {
                                const data =
                                  incomeStatementReportType === "simple"
                                    ? OPEXCategory.simple
                                    : OPEXCategory.standard;

                                // Sort periods (optional but useful for consistent display)
                                const periods = incomeStatementReport.map(
                                  (r) => r.period
                                );

                                return data.map((cData, index) => (
                                  <tr key={index}>
                                    <td className="ps-5">{cData.category}</td>
                                    {periods.map((period, pIndex) => {
                                      const match = cData.info.find(
                                        (i) => i.period === period
                                      );
                                      return (
                                        <td key={pIndex} className="text-right">
                                          <small>{businessInfo.currency}</small>{" "}
                                          {match ? match.total_amount : "0.00"}
                                        </td>
                                      );
                                    })}
                                  </tr>
                                ));
                              })()}

                              <tr className="fs-15px">
                                <th scope="row">Total Operating Expenses</th>
                                {incomeStatementReport.map((report, index) => {
                                  return (
                                    <th key={index} className="text-right">
                                      <small>{businessInfo.currency}</small>{" "}
                                      {incomeStatementReportType === "simple"
                                        ? report?.simple_report
                                            .operating_expenses.total_amount
                                        : report?.standard_report
                                            .operating_expenses.total_amount}
                                    </th>
                                  );
                                })}
                              </tr>
                              {CAPEXCategory.length > 0 && (
                                <>
                                  <tr>
                                    <td colSpan="4" className="p-3"></td>
                                  </tr>
                                  <tr>
                                    <th colSpan="4" scope="row">
                                      Capital Expenditures Expenses
                                    </th>
                                  </tr>
                                  {(() => {
                                    const data =
                                      incomeStatementReportType === "simple"
                                        ? CAPEXCategory.simple
                                        : CAPEXCategory.standard;

                                    // Sort periods (optional but useful for consistent display)
                                    const periods = incomeStatementReport.map(
                                      (r) => r.period
                                    );

                                    return data.map((cData, index) => (
                                      <tr key={index}>
                                        <td className="ps-5">
                                          {cData.category}
                                        </td>
                                        {periods.map((period, pIndex) => {
                                          const match = cData.info.find(
                                            (i) => i.period === period
                                          );
                                          return (
                                            <td
                                              key={pIndex}
                                              className="text-right"
                                            >
                                              <small>
                                                {businessInfo.currency}
                                              </small>{" "}
                                              {match
                                                ? match.total_amount
                                                : "0.00"}
                                            </td>
                                          );
                                        })}
                                      </tr>
                                    ));
                                  })()}
                                  <tr className="fs-15px">
                                    <th scope="row">
                                      Total Capital Expenditures Expenses
                                    </th>
                                    {incomeStatementReport.map(
                                      (report, index) => {
                                        return (
                                          <th
                                            key={index}
                                            className="text-right"
                                          >
                                            <small>
                                              {businessInfo.currency}
                                            </small>{" "}
                                            {incomeStatementReportType ===
                                            "simple"
                                              ? report?.simple_report
                                                  .capital_expenditures_expenses
                                                  .total_amount
                                              : report?.standard_report
                                                  .capital_expenditures_expenses
                                                  .total_amount}
                                          </th>
                                        );
                                      }
                                    )}
                                  </tr>
                                </>
                              )}

                              <tr>
                                <td colSpan="4" className="p-3"></td>
                              </tr>
                              <tr className="fs-16px">
                                <th scope="row">Net Profit / (Loss)</th>
                                {incomeStatementReport.map((report, index) => {
                                  const isSimple =
                                    incomeStatementReportType === "simple";
                                  const data = isSimple
                                    ? report?.simple_report
                                    : report?.standard_report;

                                  const isProfit = data?.is_net_profit;
                                  const amount = data?.net_income || "0";

                                  const formattedAmount = isProfit
                                    ? amount
                                    : amount.replace("-", "") ||
                                      Math.abs(Number(amount)).toString();

                                  return (
                                    <td key={index} className="text-right">
                                      {isProfit ? (
                                        <span className="text-success">
                                          <small>{businessInfo.currency}</small>{" "}
                                          {formattedAmount}
                                        </span>
                                      ) : (
                                        <span className="text-danger">
                                          (
                                          <small>{businessInfo.currency}</small>{" "}
                                          {formattedAmount})
                                        </span>
                                      )}
                                    </td>
                                  );
                                })}
                              </tr>
                            </tbody>
                          </table>
                        </div>
                      </PreviewAltCard>
                    </Col>
                  </Row>
                </div>
              </Block>
            )}

            {/* filter modal */}
            {activeModal === "filterModal" && (
              <Modal isOpen={true} toggle={() => toggleModal("filterModal")}>
                <ModalHeader
                  toggle={() => toggleModal("filterModal")}
                  close={
                    <button
                      className="close"
                      onClick={() => toggleModal("filterModal")}
                    >
                      <Icon name="cross" />
                    </button>
                  }
                >
                  Filter Report
                </ModalHeader>
                <ModalBody>
                  {errorMessage && (
                    <div className="mb-3">
                      <Alert color="danger" className="alert-icon">
                        {" "}
                        <Icon name="alert-circle" /> {errorMessage}{" "}
                      </Alert>
                    </div>
                  )}
                  <div className="form-group">
                    <label className="form-label">
                      Accounting Type
                      <Button
                        type="button"
                        id="account_type_info_popover"
                        className="btn-round btn-icon text-end p-0"
                        color="muted"
                        size="sm"
                      >
                        <Icon name="info" />
                      </Button>
                      <UncontrolledPopover
                        target="account_type_info_popover"
                        placement="bottom"
                        trigger="focus"
                      >
                        <PopoverBody>
                          <div className="mb-2">
                            <b>Cash Accounting:</b> Shows revenue and expenses
                            when you physically receive or pay money. It's like
                            keeping track of your wallet transactions.
                          </div>
                          <div>
                            <b>Accrual Accounting:</b> Reflects revenue and
                            expenses when they happen, regardless of cash
                            movement. It's like tracking what you owe or are
                            owed, giving a broader financial picture.
                          </div>
                        </PopoverBody>
                      </UncontrolledPopover>
                    </label>
                    <div className="form-control-wrap">
                      <Select
                        size="large"
                        placeholder="Select period type"
                        defaultValue={accountingType}
                        style={{ width: "100%" }}
                        name="accounting_type"
                        onChange={(value) => setAccountingType(value)}
                        filterOption={(input, option) =>
                          option.value
                            .toLowerCase()
                            .indexOf(input.toLowerCase()) >= 0 ||
                          option.label
                            .toLowerCase()
                            .indexOf(input.toLowerCase()) >= 0
                        }
                        options={[
                          {
                            value: "cash_accounting",
                            label: "Cash Accounting",
                          },
                          {
                            value: "accrual_accounting",
                            label: "Accrual Accounting",
                          },
                        ]}
                        showSearch
                      />
                    </div>
                  </div>
                  <div className="form-group">
                    <label className="form-label">Period Type</label>
                    <div className="form-control-wrap">
                      <Select
                        size="large"
                        placeholder="Select period type"
                        defaultValue={periodType}
                        style={{ width: "100%" }}
                        name="period_type"
                        onChange={(value) => setPeriodType(value)}
                        filterOption={(input, option) =>
                          option.value
                            .toLowerCase()
                            .indexOf(input.toLowerCase()) >= 0 ||
                          option.label
                            .toLowerCase()
                            .indexOf(input.toLowerCase()) >= 0
                        }
                        options={[
                          { value: "month", label: "Month" },
                          { value: "year", label: "Year" },
                        ]}
                        showSearch
                      />
                    </div>
                  </div>
                  <div className="form-group">
                    <label className="form-label">Period 1</label>
                    <div className="form-control-wrap">
                      {periodType === "month" ? (
                        <DatePicker
                          selected={periodDate1}
                          onChange={(date) => setPeriodDate1(date)}
                          dateFormat="MM/yyyy"
                          showMonthYearPicker
                          isClearable
                          className="form-control form-control-lg date-picker"
                        />
                      ) : (
                        <DatePicker
                          selected={periodDate1}
                          onChange={(date) => setPeriodDate1(date)}
                          dateFormat="yyyy"
                          showYearPicker
                          isClearable
                          className="form-control form-control-lg date-picker"
                        />
                      )}
                    </div>
                  </div>

                  <div className="form-group">
                    <label className="form-label">Period 2</label>
                    <div className="form-control-wrap">
                      {periodType === "month" ? (
                        <DatePicker
                          selected={periodDate2}
                          onChange={(date) => setPeriodDate2(date)}
                          dateFormat="MM/yyyy"
                          showMonthYearPicker
                          isClearable
                          className="form-control form-control-lg date-picker"
                        />
                      ) : (
                        <DatePicker
                          selected={periodDate2}
                          onChange={(date) => setPeriodDate2(date)}
                          dateFormat="yyyy"
                          showYearPicker
                          isClearable
                          className="form-control form-control-lg date-picker"
                        />
                      )}
                    </div>
                  </div>

                  <div className="form-group">
                    <label className="form-label">Period 3</label>
                    <div className="form-control-wrap">
                      {periodType === "month" ? (
                        <DatePicker
                          selected={periodDate3}
                          onChange={(date) => setPeriodDate3(date)}
                          dateFormat="MM/yyyy"
                          showMonthYearPicker
                          isClearable
                          className="form-control form-control-lg date-picker"
                        />
                      ) : (
                        <DatePicker
                          selected={periodDate3}
                          onChange={(date) => setPeriodDate3(date)}
                          dateFormat="yyyy"
                          showYearPicker
                          isClearable
                          className="form-control form-control-lg date-picker"
                        />
                      )}
                    </div>
                  </div>
                </ModalBody>
                <ModalFooter className="bg-lighter justify-content-center">
                  <Button
                    color="primary"
                    onClick={() => {
                      getIncomeStatement(businessID);
                    }}
                    size="lg"
                  >
                    {loading ? (
                      <Spinner size="sm" color="light" />
                    ) : (
                      "Apply Filter"
                    )}
                  </Button>
                </ModalFooter>
              </Modal>
            )}

            {/* info modal */}
            {activeModal === "infoModal" && (
              <InfoModal
                index="info"
                showModal={true}
                toggleModal={() => toggleModal("infoModal")}
                // headerText={`Profit & Loss Report Types`}
                rightButtonText={`Close`}
                rightButtonOnClick={() => toggleModal("infoModal")}
              >
                <div className="text-start mt-5 pt-2">
                  <div class="nk-block-content-head">
                    <h5 className="fw-normal">Simple Report</h5>
                    <p class="text-soft">
                      Includes all income and all expenses, including inventory
                      or raw material purchases — even if the items haven’t been
                      sold yet. It’s a quick, overall view of how much you’re
                      spending vs earning.
                    </p>
                  </div>
                  <hr />
                  <div class="nk-block-content-head">
                    <h5 className="fw-normal">Standard Report</h5>
                    <p class="text-soft">
                      Only includes the cost of inventory that has been sold
                      (COGS). Inventory that is purchased but not yet sold is
                      not included as an expense. This gives a more accurate
                      profit based on actual sales.
                    </p>
                  </div>
                </div>
              </InfoModal>
            )}
          </>
        )}
      </Content>
    </React.Fragment>
  );
};

export default ProfitAndLoss;
